<h2 mat-dialog-title>IMPORTANT NOTICES</h2>
<mat-dialog-content class="mat-typography">
  <h3>1. All applicants are to apply with their results.</h3>
  <p></p>

  <h3>2. Application without results is considered as <b>INCOMPLETE</b>.</h3>
  <!-- <p>Achieve the maximum speed possible on the Web Platform today, and take it further, via Web
    Workers and server-side rendering. Angular puts you in control over scalability. Meet huge
    data requirements by building data models on RxJS, Immutable.js or another push-model.</p> -->

  <h3>3. Students awaiting their results can apply, <b>BUT</b> will have to update their applications with their result when they are released</h3>
  <!-- <p>Build features quickly with simple, declarative templates. Extend the template language with
    your own components and use a wide array of existing components. Get immediate Angular-specific
    help and feedback with nearly every IDE and editor. All this comes together so you can focus
    on building amazing apps rather than trying to make the code work.</p> -->


<!--
  <h3>Architecture overview</h3>

  <p>Angular is a platform and framework for building client applications in HTML and TypeScript.
  Angular is itself written in TypeScript. It implements core and optional functionality as a
  set of TypeScript libraries that you import into your apps.</p>

  <p>The basic building blocks of an Angular application are NgModules, which provide a compilation
  context for components. NgModules collect related code into functional sets; an Angular app is
  defined by a set of NgModules. An app always has at least a root module that enables
  bootstrapping, and typically has many more feature modules.</p>

  <p>Components define views, which are sets of screen elements that Angular can choose among and
  modify according to your program logic and data. Every app has at least a root component.</p> -->


</mat-dialog-content>
<mat-dialog-actions align="end">
  <!-- <button mat-button mat-dialog-close>Cancel</button> -->
  <button mat-button [mat-dialog-close]="true" (click)="onWasHelpful()"  cdkFocusInitial>Agree</button>
</mat-dialog-actions>

